const SvgInfoBlue = (props) => {
	return (
		<svg
			width="14"
			height="14"
			viewBox="0 0 14 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M6.99992 0.333313C3.31992 0.333313 0.333252 3.31998 0.333252 6.99998C0.333252 10.68 3.31992 13.6666 6.99992 13.6666C10.6799 13.6666 13.6666 10.68 13.6666 6.99998C13.6666 3.31998 10.6799 0.333313 6.99992 0.333313ZM7.66659 10.3333H6.33325V6.33331H7.66659V10.3333ZM7.66659 4.99998H6.33325V3.66665H7.66659V4.99998Z"
				fill="#4383E3"
			/>
		</svg>
	);
};

export default SvgInfoBlue;
